import React from "react";
import Typography from "@material-ui/core/Typography";
const SalesLifeCycle = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Sales Life Cycle
      </Typography>
      <Typography paragraph variant="h5">
        Collaborate with the team to handle sales life cycle
      </Typography>
      <Typography paragraph variant="body1">
        Sales Life Cycle is one of the features under the CRM module to perform
        pre-sales transactions particularly to manage and track the pre-sales
        cycle from contacting and dealing with the potential customer, until
        proposing the quotation. It contains any information regarding the
        current status of the potential customer approached, the quotation
        proposed to the potential customer, and the sales won or lost status.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Sales Life Cycle
        list. It is displayed like a set of cards in each container representing
        the Sales Life Cycle steps. The data that appear on each card consist of
        Sales Card Title, Lead or Customer Name, Estimation Value, Proposed
        Quotation Status, Sales Card Created Date, and Sales Card Assignment.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 2 buttons that appear on each card of Sales Life
        Cycle data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Sales Card</b>
        <br />
        This button only appears if the Sales Card position is not in 'Sales
        Won' and 'Sales Lost'. It is used to edit the Sales Card data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Card Detail</b>
        <br />
        This button is used to navigate to the Sales Card detail which contains
        some tabs with details below:
        <ul>
          <li>
            <b>Sales Card</b> : This tab is to display the Sales Card data.
          </li>
          <li>
            <b>Quotation</b> : This tab is to display any Quotation related to
            the Sales Card.
          </li>
          <li>
            <b>Visit Schedules</b> : This tab is to display any Visit Schedules
            related to the Sales Card.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Sales Card.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the Sales
            Card.
          </li>
        </ul>
        When opening the Sales Card detail, there will be 1 button appearing on
        the middle section. The button is 'Delete Sales Card' which is used to
        delete the Sales Card data. The button only appears when the Sales Card
        position is not in 'Sales Won' and 'Sales Lost', otherwise button
        'Archive' will appear instead.
      </Typography>
    </React.Fragment>
  );
};

export default SalesLifeCycle;
